'use strict';

module.exports = require('superagent-promise')(require('superagent'), Promise);


/*****************
 ** WEBPACK FOOTER
 ** ./~/sync-db/lib/superagent.js
 ** module id = 4
 ** module chunks = 0
 **/